<template>
  <div>
    <v-tabs
      v-model="tab_t"
      show-arrows
    >
      <v-tab
        v-for="tab in tabs_t"
        :key="tab.title"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>
    <!-- tabs item -->
    <v-tabs-items v-model="tab_t">
      <v-tab-item>
        <account
          :cropped="cropped"
          :branch="branch"
          :data="member_information"
        ></account>
      </v-tab-item>
      <v-tab-item>
        <search-member-regular-savings :is_member_only="true">
        </search-member-regular-savings>
      </v-tab-item>
      <v-tab-item>
        <v-tabs
          v-model="loan_tab"
          show-arrows
        >
          <v-tab
            v-for="tab in loan_tabs"
            :key="tab.title"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="loan_tab">
          <v-tab-item>
            <money-loans
              :data="loans_history"
              :member_data="member_information"></money-loans>
          </v-tab-item>
          <v-tab-item>
            <gadget-loans
              :data="gadget_loans_history"
              :member_data="member_information"></gadget-loans>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
      <v-tab-item>
        <loan-savings
          :data="loans_history"
        ></loan-savings>
      </v-tab-item>
      <v-tab-item>
        <share-capital
          :data="share_capital_history"
        ></share-capital>
      </v-tab-item>
      <v-tab-item>
        <time-deposit
          :data="time_deposit_history"
        ></time-deposit>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>

import {mapActions, mapGetters} from "vuex";
import {
  mdiPrinter,
  mdiDelete,
  mdiEyeOutline,
  mdiCash100,
  mdiAccountClock,
  mdiCashMinus,
  mdiCashPlus,
  mdiAccountSearchOutline,
  mdiBookOpenPageVariantOutline,
  mdiAccountCashOutline,
  mdiAccountOutline, mdiContentSaveMoveOutline, mdiCash, mdiCellphone,
} from '@mdi/js'

import SearchMemberRegularSavings from "@/views/search_interface/SearchMemberRegularSavings";
import Account from '@/views/search_interface/member_components/Account'
import MoneyLoans from '@/views/search_interface/member_components/MoneyLoans'
import GadgetLoans from '@/views/search_interface/member_components/GadgetLoans'
import TimeDeposit from '@/views/search_interface/member_components/TimeDeposit'
import LoanSavings from '@/views/search_interface/member_components/LoanSavings'
import ShareCapital from '@/views/search_interface/member_components/ShareCapital'

export default {
  components: {
    SearchMemberRegularSavings,
    Account,
    MoneyLoans,
    GadgetLoans,
    TimeDeposit,
    LoanSavings,
    ShareCapital,
  },
  setup() {
    return {
      icons: {
        mdiPrinter,
        mdiDelete,
        mdiEyeOutline,
        mdiCash100,
        mdiAccountClock,
        mdiCashMinus,
        mdiCashPlus,
        mdiAccountSearchOutline,
        mdiBookOpenPageVariantOutline,
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiContentSaveMoveOutline,
        mdiCash,
        mdiCellphone,
      },
    }
  },
  data() {
    return {
      tab_t: '',
      tabs_t: [
        {title: 'INFORMATIONS', icon: mdiAccountOutline},
        {title: 'SAVINGS', icon: mdiAccountCashOutline},
        {title: 'LOANS', icon: mdiBookOpenPageVariantOutline},
        {title: 'LOAN SAVINGS', icon: mdiContentSaveMoveOutline},
        {title: 'SHARE CAPITAL', icon: mdiCash100},
        {title: 'TIME DEPOSIT', icon: mdiAccountClock},
      ],
      loan_tab: '',
      loan_tabs: [
        {title: 'MONEY', icon: mdiCash},
        {title: 'APPLIANCES/GADGETS', icon: mdiCellphone},
      ],


      cropped: this.avatarImg,
      branch: '',
      member_information: {},
      loans_history: [],
      gadget_loans_history: [],
      time_deposit_history: [],
      share_capital_history: [],
      mortuary_insurance_history: [],
      foundation_history: [],
      raw_lots_history: [],
    }
  },
  mounted() {
    this.search_all_members({
      search_by_id: this.member_id
    })
      .then(response => {
        let search_items = response.data
        if (search_items.length>0){
          let index = 0
          this.cropped = search_items[index].image
          this.branch = search_items[index].branch
          this.member_information = search_items[index].member
          this.loans_history = search_items[index].loans
          this.gadget_loans_history = search_items[index].gadget_loans
          this.time_deposit_history = search_items[index].time_deposit
          this.share_capital_history = search_items[index].share_capital
          this.mortuary_insurance_history = search_items[index].mortuary_insurance
          this.foundation_history = search_items[index].foundation
          this.raw_lots_history = search_items[index].raw_lots
        }
      })
  },
  computed: {
    ...mapGetters('authentication', ['position', 'member_id', 'branch_id', 'branch_address', 'branch_contact_no', 'name', 'id_no']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('members_information', ['search_all_members']),
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  }
}
</script>
